// extracted by mini-css-extract-plugin
export default {"content":"HubHome_content__otPlL","accountHolder":"HubHome_accountHolder__Y7CL2"};